import { Content } from "@/ui/Content";
import * as additionalComponents from "@/components/JobsPage";
import { router } from "@/router";
import { stripTags } from "@/functions/stripTags";
import { getGlobal } from "@/functions/getGlobal";
import sourceflowEnums from "@/sourceflow.enums";

export default function Page({ content }) {
  return (
    <>
      <Content items={content} additionalComponents={additionalComponents} />
    </>
  );
}

export async function getStaticProps({}) {
  const global = getGlobal();
  const routerKey = "jobs";
  const titleKey = "page.jobs.banner.title";

  return {
    props: {
      meta: {
        en: {
          title: stripTags(global[`${titleKey}.en`]),
          link: router[routerKey]["en"],
        },
      },
      router: router[routerKey],
      content: [
        { component: "JobsPageBannerSection", props: { variant: "quaternary", pathPrefix: "page.join-us.jobs" } },
        {
          component: "JobsPageFeedSection",
          props: {
            className: "pb-md-5 mb-4 mb-md-5",
            variant: "internal",
            prefilters: { [sourceflowEnums.categories.sectors.id]: [sourceflowEnums.categories.sectors.internal] },
            exclude: {
              [sourceflowEnums.categories.sectors.id]: true,
              [sourceflowEnums.categories.locations.id]: true,
            },
            jobsUrl: "/join-us/jobs",
            pathPrefix: "jobs.join-us.search",
          },
        },
      ],
    },
  };
}
